import {
  getAboveNode,
  getNode,
  getParentNode,
  getPluginType,
  isCollapsed,
  ELEMENT_TODO_LI,
} from '@udecode/plate';
import { Range } from 'slate';

/**
 * Returns the nearest li and ul / ol wrapping node entries for a given path (default = selection)
 */
export const getTodoListItemEntry = (
  editor,
  { at = editor.selection } = {},
) => {
  const todoType = getPluginType(editor, ELEMENT_TODO_LI);

  let _at;

  if (Range.isRange(at) && !isCollapsed(at)) {
    _at = at.focus.path;
  } else if (Range.isRange(at)) {
    _at = at.anchor.path;
  } else {
    _at = at;
  }

  if (_at) {
    const node = getNode(editor, _at);
    if (node) {
      const listItem = getAboveNode(editor, {
        at: _at,
        match: { type: todoType },
      });

      if (listItem) {
        const list = getParentNode(editor, listItem[1]);

        return { list, listItem };
      }
    }
  }
};